import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.css']
})
export class ToggleSwitchComponent implements OnInit {

  @Input() switch: boolean = false;
  @Output() switchChange = new EventEmitter<any>();

  @Input() set trueColor(color: string){
    this._trueColor = color;
    console.log("set true color to: ", this._trueColor);
  };
  @Input() set falseColor(color: string){
    this._falseColor = color;
    console.log("set false color to: ", this._falseColor);
  };

  _trueColor: string = "#2196F3";
  _falseColor: string = "#ccc";
  currentColor = this.falseColor;

  constructor() { }

  ngOnInit() {
    this.toggle();
  }

  toggle(){
    this.switchChange.emit(this.switch);
    this.currentColor = this.switch ? this._trueColor : this._falseColor;
  }

}
